import React from 'react'
import styled from 'styled-components'
import { Box, MainHeading, SpanStyled, TextStyled, TextStyledSem } from '../../ui/Elements'
import { ContactButton } from '../../ui/CustomElements'
import { useTranslation } from 'react-i18next'
import { Help, ArrowRight, HelpBg, Phone } from '../../ui/AllImages'


const HelpCard = () => {
    const { t } = useTranslation()
    const WhatsApp = () => {
        const phoneNumber = '+966531315042';
        const whatsappURL = `https://wa.me/${phoneNumber}`;
        window.open(whatsappURL, '_blank');
    };
    return (
        <HelpCardWapper className='container mb-5'>
            <Box className='help-card'>
                <Box className='about-card-text'>
                    <MainHeading className='main-heading mb-1' size="47px" color="var(--white)" transform="uppercase" lh="1.1">{t('Heavyfurniturecovered')}</MainHeading>
                    <TextStyledSem className='mb-3 helpSubText' color="var(--white)" lh="1.3">{t('Wehandleheavy')}</TextStyledSem>
                    <Box className='helpWhatsapp'>
                        <ContactButton className="whatsappBtn" bg='var(--white)' fill='var(--secondaryColor)' icon={Phone} label="+966 531315042" onClick={WhatsApp} />
                    </Box>
                    
                    <span className='about-card-img'>
                        <img className='about-img' src={Help} />
                    </span>
                </Box>

            </Box>
        </HelpCardWapper>
    )
}
const HelpCardWapper = styled.div`
margin-top: -10px;
    .help-card{
        background-image: url(${HelpBg});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;

        border-radius: 16px;
        position: relative;
    }
    
    
    .about-card-text{
        position: relative;
        padding: 0px 650px 0px 80px;
        height: 330px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: center;
        & > *{
            width: 100%;
        }
    }
    .about-card-img {
        position: absolute;
        right: 50px;
        top: -31px;
        width: 590px;
    }
    .whatsappBtn{
        margin-top: 10px;
    }
    body.rtl &{
        .about-card-text{
            padding: 0px 80px 0px 650px;
        }
        .about-card-img {
            right: auto;
            left: 50px;
            top: -31px;
        }
    }
    @media (max-width: 1199px) {
        .about-card-text{
            position: relative;
            padding: 0px 450px 0px 15px;
            
        }
        .about-card-img{
            max-width: 500px;
            right: -60px;
            top: -20px;
        }
        body.rtl &{
            .about-card-text{
                padding: 0px 15px 0px 450px;
                
            }
            .about-card-img{
                max-width: 500px;
                right: auto;
                left: -60px;
            }
        }
    }
    @media (max-width: 991px) {
        .about-card-img{
            display: none;
        }
        .about-card-text {
            height: auto;
            padding: 35px 15px 45px 15px;
            .main-heading{
                text-align: center;
                font-size: 38px;
            }
            .helpSubText{
                text-align: center;
            }
            .helpWhatsapp{
                display: flex;
                justify-content: center;
            }
        }
        body.rtl &{
            .about-card-text {
                padding: 35px 15px 45px 15px;
                .main-heading{
                    font-size: 30px;
                    line-height: 1.6;
                }
                
            }
        }
    }
    @media (max-width: 767px) {
        margin-bottom: 5px !important;
    }
    @media (max-width: 640px) {
        .about-card-text {
            
            .main-heading{
                text-align: center;
            }
            .helpSubText{
                text-align: center;
            }
            .helpWhatsapp{
                display: flex;
                justify-content: center;
            }
        }
        body.rtl &{
            .about-card-text {
                .main-heading{
                    font-size: 26px;
                    line-height: 1.4;
                }
                
            }
        }
    }
    
`

export default HelpCard
